import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Button,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import clsx from 'clsx';

import CardLoginForm from './CardLoginForm';
import CustomDivider from './Divider';
import { useStyles } from './styles';

import ROUTES_NAME from '../../../consts/routes-name';
import { FORM_LOGIN_LABELS } from '../../../consts/text/form-login';
import HOME from '../../../consts/text/home';
import { usePartner } from '../../../context/PartnerContext';

function SingleCardAccess({
  titleCorrentista,
  btnTextCorrentista,
  gtmCorrentista,
  href,
  titleNaoCorrentista,
  btnTextNaoCorrentista,
  gtmNaoCorrentista,
  icon,
}) {
  const navigate = useNavigate();
  const classes = useStyles();
  const isMobile = useMediaQuery(useTheme().breakpoints.down('xs'));
  const { isNotBB } = usePartner();

  const handleClick = (_href) => {
    window.open(_href, '_blank');
  };

  const renderCardLoginWL = () => (
    <>
      <Grid item container justifyContent="center" alignItems="center">
        <Typography
          className={clsx(
            classes.title,
            isNotBB ? classes.marginTitleWL : classes.marginTitleNC,
          )}
        >
          {titleNaoCorrentista}
        </Typography>
        <Typography
          className={clsx(
            classes.btnText,
            isNotBB ? classes.marginBtnTextWL : classes.marginBtnTextNC,
          )}
        >
          {btnTextNaoCorrentista}
        </Typography>
      </Grid>
      <CardLoginForm isNaoCorrentista gtm={gtmNaoCorrentista} />
    </>
  );

  const renderCardLoginBB = () => (
    <>
      <Typography className={clsx(classes.title, classes.marginTitleC)}>
        {titleCorrentista}
      </Typography>
      <Grid item container justifyContent="center" alignItems="center">
        {!isMobile && (
          <img
            src={icon}
            className={classes.icon}
            alt="Icone de acesso ao portal"
          />
        )}
        <Typography className={classes.btnText}>
          {btnTextCorrentista}
        </Typography>
      </Grid>
      <Button
        color="secondary"
        variant="contained"
        className={classes.btnAcessar}
        disableElevation
        onClick={() => handleClick(href)}
        data-testid="testBtnSingleCardAccess"
        {...gtmCorrentista}
      >
        <Typography className={classes.btnAcessarText} {...gtmCorrentista}>
          {FORM_LOGIN_LABELS.BTN_ACESSAR}
        </Typography>
      </Button>
      <CustomDivider />
      {renderCardLoginWL()}
    </>
  );

  return (
    <Grid item container alignItems="center" direction="column">
      <Grid
        item
        container
        direction="column"
        justifyContent="flex-start"
        className={classes.gridContainer}
      >
        {isNotBB ? renderCardLoginWL() : renderCardLoginBB()}
      </Grid>
      <Typography
        component="a"
        className={classes.link}
        onClick={() => navigate(ROUTES_NAME.PRIMEIRO_ACESSO)}
        data-gtm-type="click"
        data-gtm-clicktype="button"
        id="primeiro-acesso-001"
        data-gtm-name="primeiro-acesso"
      >
        {HOME.PRIMEIRO_ACESSO}
      </Typography>
    </Grid>
  );
}

export default SingleCardAccess;
